import { fetchQuery } from "../../../utils/commonComponent/fetched";

export const fetchEmployeeDetails = async (id) => {
  try {
    const query = `select employees.*, employeeDocuments.signature from employees left join employeeDocuments on employeeDocuments.employeeId = employees.id where employees.status = 1 ${id ? `and employees.id = ${id}` : ""}`;
    const employees = await fetchQuery(query);
    return employees;
  } catch (err) {
    console.log(err);
  }
};

export const fetchEmployeeOtherData = async (id) => {
  try {
    const query = `select * from employeeOtherData  where employeeId = ${id}`;
    const employees = await fetchQuery(query);
    return employees;
  } catch (err) {
    console.log(err);
  }
};

export const fetchEmployeeQualification = async (id) => {
  try {
    const query = `select * from employeeQualification  where employeeId = ${id}`;
    const employees = await fetchQuery(query);
    return employees;
  } catch (err) {
    console.log(err);
  }
};

export const fetchEmpTrainingFeedback = async (id) => {
  try {
    const query = `select * from employeeTrainingFeedback where employeeId = ${id}`;
    const employees = await fetchQuery(query);
    return employees;
  } catch (err) {
    console.log(err);
  }
};

export const fetchAssetIssueRecord = async (id) => {
  try {
    const query = `select * from employeeTrainingFeedback where employeeId = ${id}`;
    const employees = await fetchQuery(query);
    return employees;
  } catch (err) {
    console.log(err);
  }
};

export const fetchAssetRecords = async (id) => {
  try {
    const query = `select * from employeeAssetRecords where employeeId = ${id}`;
    const assetRecord = await fetchQuery(query);
    return assetRecord;
  } catch (err) {
    console.log(err);
    return [];
  }
};

export const fetchSurveyorMonitoringReport = async (id) => {
  try {
    const query = `select * from employeeSurveyorOnsite where employeeId = ${id}`;
    const res = await fetchQuery(query);
    return res;
  } catch (err) {
    console.log(err);
    return [];
  }
};

export const fetchSurveyorItems = async (id) => {
  try {
    const query = `select * from SurveyorOnSiteItems where employeeId = ${id}`;
    const res = await fetchQuery(query);
    return res;
  } catch (err) {
    console.log(err);
    return [];
  }
};

export const fetchEmployeeNdtMethods = async (employeeId) => {
  try {
    const query = `select * from employeeNdtMethods where employeeId = ${employeeId}`;
    return await fetchQuery(query);
  } catch (err) {
    console.log(err);
  }
};

export const fetchEmployeeForms = async (id) => {
  try {
    const query = `select * from EmployeeForms where employeeId = ${id}`;
    const employeeForms = await fetchQuery(query);
    return employeeForms;
  } catch (err) {
    console.log(err);
  }
};

export const fetchEmployeeJobDescription = async (id) => {
  try {
    const query = `
      select ejd.*, jdm.*
      from employeeJobDescription ejd
      left join jobDescriptionMaster jdm on ejd.jobdescriptionMasterId = jdm.id
      where ejd.employeeId = ${id}
    `;
    const employeeJobDescription = await fetchQuery(query);
    return employeeJobDescription;
  } catch (err) {
    console.log(err);
  }
};